import styled from 'styled-components';
import { subjectTypes } from '../../@types/entities/subjects.entity';
import getSubjectsType from '../../utils/get-Subject-Types';

type PropsMateria = {
  $subject: subjectTypes | string;
  $color: 10 | 20 | 30 | 40 | 50;
}

export const Container = styled.div<PropsMateria>`
  position: relative;
  background-color: ${({ theme, $subject: subject, $color: color }) => getSubjectsType({ color, subject, theme })};
  font-size: 20px;
  margin: 2em auto;

  p ul, p .listaBullets{
    padding: 0;
    padding-left: 1.5em !important;
  }

 p p{
    padding: 0 !important
  }

  @media screen and (max-width: 600px){
    background: transparent;
  }
`;

export const ContentBox = styled.div`
  font-size: 17px;
  margin: 0 auto;
  padding: 30px 0;

  ${({ theme }) => theme.typography.normal};
`;

export const Content = styled.p`
  font-size: 17px !important;

  p:first-of-type{
    display: none;
  }
`;

export const Title = styled.div<PropsMateria>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.125rem;

  ${({ theme }) => theme.spacing.articleBody}

  color: ${({ theme, $subject: subject }) => getSubjectsType({ color: 10, subject, theme })};

  h6 {
    ${({ theme }) => theme.typography.h6};
    text-decoration: none;
  }

  img {
    width: 100%;
  }

  figure {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme, $subject: subject, $color: color }) => getSubjectsType({ color, subject, theme })};
    width: 2.5rem;
    height: 2.31rem;
    padding: 0.4rem;
    border-radius: 0.35rem;
  }
`;

export const WrapIcon = styled.div<PropsMateria>`
  color: ${({ theme, $subject: subject }) => getSubjectsType({ color: 20, subject, theme })};
  fill: currentColor;
  display: flex;
`;
